const toHex32 = (amount) => {
  const hex = amount.toString(16);
  return "0x".concat("0".repeat(64 - hex.length)).concat(hex);
};
export {
  toHex32
};
//# sourceMappingURL=toHex32.js.map